import { atom } from "recoil";

export type popupFlagType = {
  noResultPopup: boolean;
  sharePopup: boolean;
  noGPSPopup: boolean;
  locationPopup: boolean;
};

export const popupFlagState = atom<popupFlagType>({
  key: "popupFlagState",
  default: {
    noResultPopup: false,
    sharePopup: false,
    noGPSPopup: false,
    locationPopup: false,
  },
});

// 고급 검색 팝업 상태를 관리하는 atom 추가
export const advancedSearchPopupState = atom<boolean>({
  key: "advancedSearchPopupState",
  default: false,
});
